// English translation

const en = {
  "menu.hotel_rack": "RACK",
  "hotel.rack.add_booking": "Add Booking",
  "hotel.rack.add_maintenance": "Add Maintenance",
  "hotel.rack.operation_center": "Operation Center",
  "hotel.rack.lockout_added": "Lockout added successfully!",
  "maintenance.request_service": "Add Maintenance",
  "maintenance.request_service.priority": "Priority",
  "maintenance.request_service.description": "Description",
  "maintenance.request_service.number": "Number",
  "maintenance.request_service.room": "Room",
  "maintenance.request_service.start_date": "Start Date",
  "maintenance.request_service.end_date": "End Date",
  "maintenance.request_service.total_days": "Total Days",
  "maintenance.request_service.confirm": "Confirm",
  "maintenance.request_service.state": "State",
  "maintenance.request_service.approved_notes":"Approve Notes"

};

export default en;
